module.exports = __webpack_public_path__ + "static/dashboard-freemium-1-6b6662fc33b5d33fff67c123f48cca5a.png";